// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-2_fvJ";
var _4 = "insuranceCard__header-3imkg";
var _5 = "insuranceCard__wrapper-21OMQ";
var _6 = "insuranceCard__active-1r6Ou";
var _7 = "insuranceCard__headerPrice-4z2Bn";
var _8 = "content-3sevE";
var _9 = "footer-25fxN";
var _a = "insuranceCard__content-3oLF2";
var _b = "additionalServices__paper-U17Rx";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "insuranceCard__header", _5 as "insuranceCard__wrapper", _6 as "insuranceCard__active", _7 as "insuranceCard__headerPrice", _8 as "content", _9 as "footer", _a as "insuranceCard__content", _b as "additionalServices__paper" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "insuranceCard__header": _4, "insuranceCard__wrapper": _5, "insuranceCard__active": _6, "insuranceCard__headerPrice": _7, "content": _8, "footer": _9, "insuranceCard__content": _a, "additionalServices__paper": _b }
